import { default as React, useEffect } from "react"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import SideBar from "../../../common/layout/sidebar.component"
import LoadingSpinner from "../../../common/spinner/loading.component"
import { PropsType } from "../../../state/contact/models/types"
import { fetchSupplier } from "../../../state/contact/reducers"
import { Selector } from "../../../state/contact/selectors/selectors"
import SupplierForm from "./SupplierForm"


const SupplierPage = (props: PropsType) => {
    const supplierId = props.match.params.supplierId
    const dispatch = useDispatch()
    const contact = useSelector(Selector.get)

    useEffect(() => {
        SideBar.activateMenu("contact")
        if (supplierId) {
            dispatch(fetchSupplier(supplierId))
        }
    }, [])

    if(contact.isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>  
            <div className="mb-4">
                {((supplierId && contact?.name!="") || !supplierId) &&
                    <SupplierForm
                        contactId={supplierId}
                        contact={supplierId ? contact : null}
                    />}
            </div>
        </>
    )
}
export default injectIntl(SupplierPage)





// WEBPACK FOOTER //
// ./src/customer/supplier/components/SupplierPage.tsx